<template>
  <div>
    <!----------------- Main contents Area --------------------->
    <!-- mt-3: margin top-3 -->
    <main class="mt-3">
      <div class="container">
        <div class="alert alert-secondary" role="alert">
          <b class="fs-4">코드별 표시순서정보  <span style="font-size:small; color: red;">※ 999는 순서미지정 (무순위 상태)</span> </b>
        </div>
        <div style="display: flex; width:100%;">
          <div style="width: 49%; margin-right: 1%;">
            <div>
              <label class="text-danger">[ 일본지역정보 ]</label>
            </div>
            <table class="table table-bordered table-striped fs-6 align-item-atart text-center">
              <thead class="small">
                <tr>
                  <!-- <th style="width:40px;">
                    <input class="form-check-input" type="checkbox" v-model="allSelected" @change="allChoice()" />
                  </th> -->
                  <th style="width:20%">순서</th>
                  <th style="width:10%">코드</th>
                  <th style="width:30%">지역명</th>
                  <th style="width:20%">사용여부</th>
                  <th style="width:10%">변경</th>
                </tr>
              </thead>
              <tbody class="small">
                <tr :key="i" v-for="(m, i) in baseCodeList_ar_jp">
                  <td class="form-control-sm text-primary">
                    <input type="number" class="form-control-sm text-end" v-model="m.sort">
                  </td>
                  <td>
                    {{ m.baseCode }}
                  </td>
                  <td>
                    {{ m.codeNameKor }}
                  </td>
                  <td>
                    <select class="form-select form-select-sm" aria-label=".form-select-sm" ref="sel_pUseFlag" v-model="m.useFlag">
                      <option value="Y" class="text-success">Y</option>
                      <option value="N" class="text-danger">N</option>
                    </select>
                  </td>
                  <td>
                    <button type="button" class="btn btn-outline-primary btn-sm" style="font-size: small;" @click="update_arInfo(m.sort, m.useFlag, m.baseCode, m.categoryCode,  m.primeCatCode)">변경</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div style="width: 49%; margin-left:1%;">
            <div>
              <label class="text-primary">[ 이외지역정보 ]</label>
            </div>
            <table class="table table-bordered table-striped fs-6 align-item-atart text-center">
              <thead class="small">
                <tr>
                  <!-- <th style="width:40px;">
                    <input class="form-check-input" type="checkbox" v-model="allSelected" @change="allChoice()" />
                  </th> -->
                  <th style="width:20%">순서</th>
                  <th style="width:10%">코드</th>
                  <th style="width:30%">국가명</th>
                  <!-- <th style="width:15%">지역명</th> -->
                  <th style="width:20%">사용여부</th>
                  <th style="width:10%">변경</th>
                </tr>
              </thead>
              <tbody class="small">
                <tr :key="i" v-for="(m, i) in baseCodeList_nt_et">
                  <td class="form-control-sm text-primary">
                    <input type="number" class="form-control-sm text-end" v-model="m.sort2">
                  </td>
                  <td>
                    {{ m.baseCode }}
                  </td>
                  <td>
                    {{ m.ntName }}
                  </td>              
                  <!-- <td>
                    {{ m.codeNameKor }}
                  </td> -->
                  <td>
                    <select class="form-select form-select-sm" aria-label=".form-select-sm" ref="sel_pUseFlag" v-model="m.useFlag">
                      <option value="Y" class="text-success">Y</option>
                      <option value="N" class="text-danger">N</option>
                    </select>
                  </td>
                  <td>
                    <button type="button" class="btn btn-outline-primary btn-sm" style="font-size: small;" @click="update_ntInfo(m.sort2, m.useFlag, m.baseCode, m.primeCatCode)">변경</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  // DB에서 가져온 데이타
  data() {
    return {
      baseCodeList: [],           //기본코드리스트
      baseCodeList_ar_jp: [],     //일본지역
      baseCodeList_nt_et: [],     //그 외 국가코드
    };
  },
  created() {
    //this.productId = this.$route.query.productId;
    this.user = this.$store.state.user;

    this.getBaseCodeList()
  }, 

  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  mounted() {
    if(document.referrer == "") {
      this.$swal.fire('', '적절하지 않은 페이지 접근입니다.', 'error');
      location.replace("/")
    }
    //권한없는 로그인 차단
    if(this.user.handlerGrade >= 20) {
      var swal = require('sweetalert2');
      swal.fire({
        title: '로그인 필요',
        text: '접근권한 확인불가.',
        icon: 'error'
      });
      this.$router.push({path: '/'});
    }
    ////document.getElementById("notice").style.display = "none";
    document.getElementById("user").style.display = "none";    
  },
  methods: {
    //memberInfo: 회원정보리스트용 sql
    getDateFormat(date) {
      return this.$dateFormat(date);
    },
    // mixins에 있는 공통함수 호출샘플
    getCurrencyFormat(value) {
      return this.$currencyFormat(value);
    },

    async getBaseCodeList() {
      let baseCodeList = await this.$api("/api/baseCodeList_jp", {})
      let baseCodeList_nt_et = await this.$api("/api/baseCodeList_et", {})
      
      if(baseCodeList.length > 0)
      {
        this.baseCodeList = baseCodeList
      }

      let baseCodeList_ar_jp = []        //일본지역코드
      baseCodeList_ar_jp = this.baseCodeList
      .filter(e => {
        return ( e.categoryCode === 'JP' && e.primeCatCode === 'arCd' )
      })
      this.baseCodeList_ar_jp = baseCodeList_ar_jp

      if(baseCodeList_nt_et.length > 0)
      {
        this.baseCodeList_nt_et = baseCodeList_nt_et
      }
      //console.log("baseCodeList_nt_et>>>>", this.baseCodeList_nt_et)
    },

    // update_arInof(m.sort, m.useFlag, m.baseCode, m.categoryCode, m.primeCatCode)
    async update_arInfo(sort, useFlag, bCode, ctCode, ptCode){
      let upd_baseCodeInfo = await this.$api("/api/upd_baseCodeInfo", {param: [
        sort, useFlag, ptCode, bCode, ctCode
      ]})
      //console.log("upd_baseCodeInfo:", upd_baseCodeInfo)
      if(upd_baseCodeInfo.affectedRows > 0)
      {
        this.$swal.fire("","변경이 완료되었습니다,", "success")
        .then(() => {
          // location.reload(true)
          this.getBaseCodeList()
        })
      }
    },

    // update_ntInfo(m.sort, m.useFlag, m.baseCode, m.primeCatCode)
    async update_ntInfo(sort, useFlag, bCode, ptCode){
      let upd_baseCodeInfo = await this.$api("/api/upd_baseCodeInfo_et", {param: [
        sort, useFlag, ptCode, bCode
      ]})
      if(upd_baseCodeInfo.affectedRows > 0)
      {
        this.$swal.fire("","변경이 완료되었습니다,", "success")
        .then(() => {
          // location.reload(true)
          this.getBaseCodeList()
        })
      }
    },
  }
}
</script>